<template>
  <span 
    class="forma-pagamento-badge"
    :class="[badgeMeta.class, { 'forma-pagamento-badge-compact': compact }]"
    :title="badgeMeta.title"
  >
    <AppIcon 
      v-if="badgeMeta.icon" 
      :name="badgeMeta.icon" 
      :size="iconSize" 
      class="forma-pagamento-icon" 
    />
    <span v-if="showText" class="forma-pagamento-text">
      {{ badgeMeta.text }}
    </span>
  </span>
</template>

<script>
export default {
  name: "FormaPagamentoBadge",
  props: {
    forma: {
      type: [Object, String, Number],
      default: null
    },
    nome: {
      type: String,
      default: null
    },
    idForma: {
      type: [Number, String],
      default: null
    },
    tipoMeio: {
      type: String,
      default: null
    },
    size: {
      type: [Number, String],
      default: 12
    },
    showText: {
      type: Boolean,
      default: true
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconSize() {
      return Number(this.size) || 12;
    },
    badgeMeta() {
      let formaNome = this.nome || '';
      let id = this.idForma != null ? Number(this.idForma) : null;
      let meio = this.tipoMeio || '';

      if (this.forma) {
        if (typeof this.forma === 'object') {
          formaNome = this.forma.forma_pagamento_nome || this.forma.nome || this.forma.formaPagamento || formaNome;
          if (this.forma.id_forma_pagamento != null) {
            id = Number(this.forma.id_forma_pagamento);
          } else if (this.forma.id != null) {
            id = Number(this.forma.id);
          }
          meio = this.forma.tipo_meio_pagamento || meio;
        } else if (typeof this.forma === 'string') {
          formaNome = this.forma;
        } else if (typeof this.forma === 'number') {
          id = this.forma;
        }
      }

      const strNome = String(formaNome || '').toUpperCase();
      const strMeio = String(meio || '').toUpperCase();

      if (id === 6 || strMeio === 'PIX' || strNome.indexOf('PIX') !== -1) {
        return {
          text: 'PIX',
          icon: 'pix',
          class: 'badge-apple-pix',
          title: 'Forma de Pagamento: PIX'
        };
      }

      if (
        id === 2 || 
        id === 3 || 
        strMeio === 'CARTAO' || 
        strNome.indexOf('CART') !== -1 || 
        strNome.indexOf('CRED') !== -1 || 
        strNome.indexOf('DEB') !== -1
      ) {
        return {
          text: strNome.indexOf('DEB') !== -1 ? 'Débito' : 'Cartão',
          icon: 'card',
          class: 'badge-apple-cartao',
          title: 'Forma de Pagamento: Cartão'
        };
      }

      if (id === 4 || strMeio === 'BOLETO' || strNome.indexOf('BOLETO') !== -1) {
        return {
          text: 'Boleto',
          icon: 'barcode',
          class: 'badge-apple-boleto',
          title: 'Forma de Pagamento: Boleto Bancário'
        };
      }

      if (
        id === 1 || 
        strMeio === 'DINHEIRO' || 
        strNome.indexOf('DINHEIRO') !== -1 || 
        strNome.indexOf('ESPECIE') !== -1
      ) {
        return {
          text: 'Dinheiro',
          icon: 'cash',
          class: 'badge-apple-dinheiro',
          title: 'Forma de Pagamento: Dinheiro / Espécie'
        };
      }

      if (
        id === 5 || 
        strMeio === 'TRANSFERENCIA' || 
        strNome.indexOf('TRANSF') !== -1 || 
        strNome.indexOf('TED') !== -1 || 
        strNome.indexOf('DOC') !== -1
      ) {
        return {
          text: 'Transferência',
          icon: 'bank',
          class: 'badge-apple-transferencia',
          title: 'Forma de Pagamento: Transferência Bancária / TED'
        };
      }

      if (id === 10 || strMeio === 'EMPENHO' || strNome.indexOf('EMPENHO') !== -1) {
        return {
          text: 'Empenho',
          icon: 'bank',
          class: 'badge-apple-empenho',
          title: 'Forma de Pagamento: Empenho (Órgão Público / Governamental)'
        };
      }

      if (id === 15 || strMeio === 'PERMUTA' || strNome.indexOf('PERMUTA') !== -1) {
        return {
          text: 'Permuta',
          icon: 'sync',
          class: 'badge-apple-permuta',
          title: 'Forma de Pagamento: Permuta de Serviços/Produtos'
        };
      }

      if (id === 16 || strMeio === 'PAGO_OUTRO_CONTRATO' || strNome.indexOf('OUTRO CONTRATO') !== -1) {
        return {
          text: 'Outro Contrato',
          icon: 'file',
          class: 'badge-apple-outro-contrato',
          title: 'Forma de Pagamento: Faturamento vinculado a outro contrato'
        };
      }

      return {
        text: formaNome || 'Outro',
        icon: 'file',
        class: 'badge-apple-outro',
        title: 'Forma de Pagamento: ' + (formaNome || 'Outro') + (id ? ' (ID: ' + id + ')' : '')
      };
    }
  }
};
</script>

<style scoped>
.forma-pagamento-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  letter-spacing: 0.02em;
  transition: all 0.15s ease;
}

.forma-pagamento-badge-compact {
  padding: 2px 6px;
  font-size: 11px;
}

.forma-pagamento-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.forma-pagamento-text {
  display: inline-block;
}

.badge-apple-pix {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #15803d;
}

.badge-apple-boleto {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  color: #0369a1;
}

.badge-apple-cartao {
  background: #faf5ff;
  border: 1px solid #e9d5ff;
  color: #7e22ce;
}

.badge-apple-dinheiro {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  color: #047857;
}

.badge-apple-transferencia {
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  color: #4338ca;
}

.badge-apple-empenho {
  background: #ecfeff;
  border: 1px solid #a5f3fc;
  color: #0e7490;
}

.badge-apple-permuta {
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #b45309;
}

.badge-apple-outro-contrato {
  background: #f5f3ff;
  border: 1px solid #ddd6fe;
  color: #6d28d9;
}

.badge-apple-outro {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #475569;
}
</style>
